<template>
  <v-container>
    <br />
    <br />
    <img src="../assets/newLogo.png" alt="LOGO" style="width: 7.5%;" />
    <v-flex xs12>
      <h1>Charities</h1>
      <v-container>
        <br />
        <!-- <p>
          South Peninsula Community Group <br />
          Southern Suburbs Community Group <br />City Bowl Community Group
          <br />Northern Suburbs Community Group <br />Atlantic Seaboard
          Community Group <br />West Coast Community Group <br />Helderberg
          Community Group
        </p> -->
        <br />
        <v-layout row wrap justify-space-around>
          <v-flex
            ml-1
            mt-4
            mr-2
            xs12
            sm8
            md3
            offset-sm0
            offset-xs0
            offset-md0
            elevation-3
            v-for="(item, i) in items"
            :key="i"
          >
            <v-hover>
              <v-card
                slot-scope="{ hover }"
                :class="`elevation-${hover ? 12 : 2}`"
                class="mx-auto"
                :width="cardWidth"
                height="250"
                offset-xs0
                offset-sm0
                offset-md0
                ml-1
                mr-2
                xs12
                sm8
                md3
              >
                <hr />
                <v-card-title primary-title>
                  <div>
                    <div style=" height: 50px;">
                      <h5 class="headline mb-0">{{ item.businessName }}</h5>
                    </div>
                    <img
                      :src="item.profile_image"
                      style="width: 100%; "
                      alt="charity Image"
                    />
                  </div>
                </v-card-title>
                <v-card-text>
                  <div>
                    <div style=" height: 40px;">
                      <p class="headline mb-0">{{ item.charityName }}</p>
                    </div>
                  </div>
                </v-card-text>
                <v-card-actions>
                  <v-btn :id="item.id" :value="item.id" flat color="#305f72"
                    >See More</v-btn
                  >
                </v-card-actions>
              </v-card>
            </v-hover>
          </v-flex>
        </v-layout>
      </v-container>
    </v-flex>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      cardWidth: "250px",
      items: [
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "South Peninsula",
          charityName: "Tears"
        },
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "Southern Suburbs"
        },
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "City Bowl"
        },
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "Northern Suburbs"
        },
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "Atlantic Seaboard"
        },
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "West Coast"
        },
        {
          id: 1,
          profile_description: "lorem fgfsg sgs",
          profile_image:
            "http://localhost:3000/images/profiles/34ProfilePic.jpg",
          businessName: "Helderberg"
        }
      ]
    };
  },
  mounted() {},
  methods: {}
};
</script>

<style scoped>
.test {
  font-size: 100%;
  align-content: center;
}
</style>
